/* eslint-disable no-restricted-globals */
/* eslint-disable no-param-reassign */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { cloneDeep } from 'lodash';
import { Redirect, Link } from 'react-router-dom';
import { Form } from 'react-form';
import * as queryString from 'query-string';
import moment from 'moment';

import requireAuth from '../../components/hocs/requireAuth';
import PostScoreForm from '../../components/PostScoreForm';
import { Input } from '../../components/Form';
import { PostScoreWelcomePopUp, ScorePostedConfirmationPopup } from '../../components/PopUps';
import { PostScoreWelcomeTitles } from '../../components/PopUps/WelcomePopUps/PostScoreWelcomePopUp';

import * as searchActions from '../../actions/search-actions';
import * as headerActions from '../../actions/header-actions';
import { showSplash, hideSplash } from '../../actions/splash-actions';
import * as postScoreActions from '../../actions/post-score-actions';
import { fetchComponentConfig, postComponentActionPerformd } from '../../actions/component-config-actions';
import * as clubActions from '../../actions/club-actions';
import { getEvent } from '../../actions/event-actions';
import { isPersonalClub, ClubTierTypes } from '../../utils/clubs';
import { getApiAxiosInstance } from '../../utils/network';
import { isValidEmail } from '../../utils/validation';
import { playerProfile } from '../../api';
import { divisionFormatTypeIds, drawPositionTypeIds, sportTypeIds } from '../../utils/eventConstants';
import PickleballPostScoreForm from '../../components/PostScoreForm/PickleballPostScoreForm';
import { ratingTypes } from '../../utils/constants';
import { showErrorPopup } from '../../actions/notification-actions';

import links from '../../../config/links';

import styles from './postScore.scss';

const FLEX_EMAIL = 'Flex@universaltennis.com';

const _ = { cloneDeep };

const PostScorePage = (props) => {
    const { location } = props;
    const parsed = queryString.parse(location.search);
    const clubPostScore = props.match.path === '/:clubType(clubs|schools|colleges)/:clubId/post-score';
    const playerPostScore = location.pathname === '/player/post-score';
    const playerEventPostScore = playerPostScore && parseInt(parsed.eventId) > 0;
    const playerMatchPostScore = playerPostScore && !playerEventPostScore && !!parsed.matchId;
    const { clubId, clubType } = props.match.params;

    const [state, setState] = useState({
        showWelcomePopUp: true,
        isHighSchool: false,
        isVerifiedEvent: false,
        flexLeagueMatchPostScore: playerPostScore && parsed.flexLeagues,
    });
    const [sportTypeId, setSportTypeId] = useState(sportTypeIds.TENNIS);
    const [gameTypeId, setGameTypeId] = useState(divisionFormatTypeIds.SINGLES);

    const auth = useSelector(({ auth }) => auth);
    const postScore = useSelector(({ postScore }) => postScore);
    const events = useSelector(({ events }) => events);
    const club = useSelector(({ club }) => club);
    const componentConfig = useSelector(({ componentConfig }) => componentConfig);
    const dispatch = useDispatch();

    const { isEdit, invitees, showWelcomePopUp, clubPost, playerPost, playerEventPost, playerMatchPost, flexLeagueMatchPostScore, showInvites, teamPostScore, teamsDict } = state;

    const compConfig = componentConfig['post-scores'];
    const postWelcomePopUpConfig = compConfig && (clubPost
        ? compConfig.modals.find(m => m.type === 'club_post_score_welcome_popup')
        : compConfig.modals.find(m => m.type === 'self_post_score_welcome_popup'));

    let welcomeTitles = PostScoreWelcomeTitles.PLAYER_POST;
    if (postWelcomePopUpConfig && postWelcomePopUpConfig.type === 'club_post_score_welcome_popup') {
        welcomeTitles = teamPostScore ? PostScoreWelcomeTitles.TEAM_POST : PostScoreWelcomeTitles.CLUB_POST;
        if (teamPostScore) {
            welcomeTitles.description = (
                <>
                    Results will immediately show on team and player profiles but can be edited afterwards. Player ratings will update by the next day.
                    <br />
                    If you’re looking to post Dual Match or Official High School results, click “Create Event” on your team’s <Link to={`/schools/${club.clubId}`}>homepage</Link>
                </>
            );
        }
    }

    const isHighSchool = clubPost && club?.clubDetails?.tierType?.isHighSchool;
    const clubTierType = club?.clubDetails?.tierType;
    const forceDoubles = parseInt(gameTypeId) === divisionFormatTypeIds.DOUBLES;
    const isSingleScore = parseInt(sportTypeId) === sportTypeIds.PICKLEBALL;
    const isFlexLeagueEvent = props.history?.location?.search;
    const getComponentConfig = (selfPost, clubId) => {
        const params = {
            selfPost,
        };
        if (clubId) {
            params.clubId = clubId;
        }
        dispatch(fetchComponentConfig('post-scores', params));
    };

    const onComponentMount = async () => {
        if (clubPostScore) {
            // Call clubs api if club post score
            if (clubId) {
                getComponentConfig(false, clubId);
                dispatch(clubActions.setClubId(clubId));
                setHeader();
            } else {
                props.history.push({
                    pathname: `/home`,
                });
            }
        } else {
            if (playerEventPostScore) {
                // fetch event if player event post score
                dispatch(getEvent(parsed.eventId));
            }
            if (playerMatchPostScore) {
                dispatch(showSplash({ splash: 'load', title: 'Loading' }));
                // fetch mtach if player match post score
                dispatch(postScoreActions.getMatch(auth.user.id, parsed.matchId));
            }
            getComponentConfig(true);

            // get player profile for isPro check on post score
            const axiosInstance = getApiAxiosInstance();
            const playerResult = await playerProfile(axiosInstance, parseInt(auth.user.claimedPlayer.playerId));
            setState((prevState) => ({
                ...prevState,
                currentPlayer: playerResult.data,
            }));
            setHeader();
        }
    };
    useEffect(() => {
        if (isFlexLeagueEvent) {
            dispatch(postScoreActions.setRound({ redirectUrlPage: 'FlexLeagues' }));
        } else {
            dispatch(postScoreActions.setRound({ redirectUrlPage: 'selfPost' }));
        }
    }, []);

    useEffect(() => {
        dispatch(searchActions.setSearchPageType({ searchPageType: 'playerPostScore' }));

        onComponentMount();

        return () => {
            // reset global search back to 'lookup' mode 'players' lookupType, if a lookup wasn't completed
            dispatch(searchActions.setSearchMode({
                mode: 'search',
                lookupType: 'players',
                displayFilters: true,
                gotoSearchResults: true,
            }));
            dispatch(postScoreActions.clearMatchData());
            dispatch(searchActions.setSearchPageType({ searchPageType: 'playerPostScore' }));
        };
    }, []);

    useEffect(() => {
        let teamPostScore = false;
        // player event post score
        if (playerEventPostScore) {
            if (!events.isLoading && events.currentEvent?.error) {
                props.history.push({
                    pathname: `/home`,
                });
            }

            const event = events.currentEvent.data;
            const utcNow = moment.utc().startOf('day');

            if (event && event.utrType.value === 'sanctioned') {
                setState((prevState) => ({
                    ...prevState,
                    isVerifiedEvent: true,
                }));
            }

            /*
             * check if event is eligible for player posting scores
             * event allow player posting score is true
             * event maxPostScoreDateUtc is before now
             * current member is registerd to the event
             */
            if (event && !(event.allowPlayerPosting &&
                (event.eventSchedule && event.eventSchedule.maxPostScoreDateUtc && moment(event.eventSchedule.maxPostScoreDateUtc) >= utcNow) &&
                (Array.isArray(event.registeredMemberIds) && event.registeredMemberIds.indexOf(auth.user.id) !== -1))) {
                props.history.push({
                    pathname: `/home`,
                });
            }
        }

        // player match post score

        if (playerMatchPostScore) {
            const postableMatchups = postScore && postScore.postableMatchups;
            if (!postableMatchups.isLoading) {
                dispatch(hideSplash());
            }

            if (!postableMatchups.isLoading && postableMatchups.error) {
                props.history.push({
                    pathname: `/home`,
                });
            }

            /*
            * check if current member is in the match
            */
            const currentMatch = postableMatchups.currentMatchup;
            if (!postableMatchups.isLoading && !postableMatchups.error && currentMatch) {
                if (currentMatch.players.map(p => p.memberId).indexOf(auth.user.id) === -1) {
                    props.history.push({
                        pathname: `/home`,
                    });
                }
            }
        }

        // club post score

        if (clubPostScore) {
            const { clubDetailsFetched, clubDetails } = club;
            teamPostScore = clubDetails?.tierType?.id === ClubTierTypes.HIGH_SCHOOL || clubDetails?.tierType?.id === ClubTierTypes.PERFORMANCE_HIGH_SCHOOL;
            const currentMemberRole = (clubDetails && clubDetails.currentMember && clubDetails.currentMember.role);
            const isAdminOrOwner = (currentMemberRole === 'Owner' || currentMemberRole === 'Admin');
            // check if admin
            if (clubDetailsFetched && clubDetails && !isAdminOrOwner) {
                props.history.push({
                    pathname: `/${clubType}/${clubId}`,
                });
            }

            if (clubDetailsFetched && !clubDetails) {
                props.history.push({
                    pathname: `/home`,
                });
            }
        }

        const isEdit = !!postScore.result;
        let match = [];
        const teamsDict = {};
        const playersDict = {};

        if (isEdit) {
            const { result } = postScore;
            setSportTypeId(result.sportTypeId);
            if (result.gameType === 'doubles') {
                const winningTeam = createTeamObject(result.players.winner1, result.players.winner2);
                const losingTeam = createTeamObject(result.players.loser1, result.players.loser2);
                teamsDict[`${winningTeam.id}`] = winningTeam;
                teamsDict[`${losingTeam.id}`] = losingTeam;
                playersDict[`${result.players.winner1.id}`] = result.players.winner1;
                playersDict[`${result.players.winner2.id}`] = result.players.winner2;
                playersDict[`${result.players.loser1.id}`] = result.players.loser1;
                playersDict[`${result.players.loser2.id}`] = result.players.loser2;
                match.position1 = {
                    id: winningTeam.id,
                    type: {
                        id: 2,
                        value: 'team',
                    },
                };
                match.position2 = {
                    id: losingTeam.id,
                    type: {
                        id: 2,
                        value: 'team',
                    },
                };
            } else {
                playersDict[`${result.players.winner1.id}`] = result.players.winner1;
                playersDict[`${result.players.loser1.id}`] = result.players.loser1;
                match.position1 = {
                    id: result.players.winner1.id,
                    type: {
                        id: 2,
                        value: 'player',
                    },
                };
                match.position2 = {
                    id: result.players.loser1.id,
                    type: {
                        id: 2,
                        value: 'player',
                    },
                };
            }
            match = populateMatchPlayers(match, playersDict, teamsDict);
            match.result = result;
            match.date = result.date;
        } else {
            let pos1player1;
            if (playerMatchPostScore) {
                const postableMatchups = postScore && postScore.postableMatchups;

                if (!postableMatchups.isLoading && postableMatchups.currentMatchup) {
                    const currentMatch = postableMatchups.currentMatchup;
                    setSportTypeId(currentMatch.sportTypeId);
                    currentMatch.players.forEach((player) => {
                        playersDict[player.id] = player;
                    });
                    if (currentMatch.position1.type && currentMatch.position1.type.value === 'team') {
                        teamsDict[currentMatch.position1.id] = { players: currentMatch.position1.playerIds };
                    }
                    if (currentMatch.position1.type && currentMatch.position1.type.value === 'team') {
                        teamsDict[currentMatch.position2.id] = { players: currentMatch.position2.playerIds };
                    }
                    match = populateMatchPlayers(currentMatch, playersDict, teamsDict);
                    match.date = currentMatch.date;
                }
            } else {
                if (playerPostScore) {
                    pos1player1 = auth.user.claimedPlayer;
                    pos1player1.id = pos1player1.playerId;
                } else if (clubPostScore) {
                    ({ pos1player1 } = postScore);
                }
                match = {
                    pos1player1,
                    pos2player1: postScore.pos2player1,
                    pos2player2: postScore.pos2player2,
                    pos1player2: postScore.pos1player2,
                };
            }
        }

        setState((prevState) => ({
            ...prevState,
            match,
            isEvent: !!match.eventId,
            isEdit,
            playerPost: playerPostScore,
            playerEventPost: playerEventPostScore,
            playerMatchPost: playerMatchPostScore,
            flexLeagueMatchPostScore: playerPostScore && parsed.flexLeagues,
            clubPost: clubPostScore,
            teamPostScore,
            playerDict: playersDict,
            teamsDict,
        }));
        setHeader();
    }, [events.isLoading, events.currentEvent, postScore, club.clubDetailsFetched, club.clubDetails]);

    const getInviteeList = (postData) => {
        const playerTypes = ['winner1', 'winner2', 'loser1', 'loser2'];
        const invitees = [];
        playerTypes.forEach((playerType) => {
            if (postData && postData[`${playerType}`] && postData[`${playerType}`].invite) {
                const invitee = _.cloneDeep(postData[`${playerType}`]);
                invitee.key = playerType;
                invitees.push(invitee);
            }
        });
        return invitees;
    };

    const setHeader = () => {
        const headerObject = props.route.header;
        const isEdit = !!postScore.result;

        if (playerPostScore) {
            if (playerEventPostScore) {
                headerObject.title = isEdit ? 'Edit Your Score' : 'Post Your Score';
                headerObject.subTitle = `Self-post event score to count towards your ${ratingTypes.tennis} rating`;
                headerObject.closeHandleClick = parsed.redirectUrl || '/home';

                if (state.isVerifiedEvent) {
                    headerObject.titleInfo = (
                        <ul>
                            <li>These self-posted scores will count as <a href={links.diffVerifiedUtr} target="_blank" rel="noopener noreferrer" data-testid="post-score-page.a-376">Verified</a>.</li>
                            <li>Only self-post scores from individual play. If you want to post scores from an <a href={links.countsToUTR} target="_blank" rel="noopener noreferrer" data-testid="post-score-page.a-377">organized event</a>, please contact the event organizer to post results for the entire event.</li>
                            <li>Your opponents must review and confirm the score before it is posted publicly on player profiles. Until the score is confirmed, it will be in a “pending” state.</li>
                            <li>Once the opponent has confirmed the score it will be reviewed and approved by our team and only then will it count towards the player ratings.</li>
                            <li>Match score must meet minimum Verified UTR requirements.</li>
                        </ul>
                    );
                } else {
                    headerObject.titleInfo = (
                        <ul>
                            <li>Self-posted scores are not <a href={links.diffVerifiedUtr} target="_blank" rel="noopener noreferrer" data-testid="post-score-page.a-386">Verified</a>.</li>
                            <li>Only self-post scores from individual play. If you want to post scores from an <a href={links.countsToUTR} target="_blank" rel="noopener noreferrer" data-testid="post-score-page.a-387">organized event</a>, please contact the event organizer to post results for the entire event.</li>
                            <li>Your opponents must review and confirm the score before it is posted publicly on player profiles and counts for the rating. Until the score is confirmed, it will be in a “pending” state.</li>
                            <li>You can delete that you posted incorrectly.</li>
                            <li>Once the posted score is confirmed, everyone’s ratings will update by the next day.</li>
                            <li>If your opponent(s)/partner are not on UTR Sports, you will have to invite them via email. The score will remain in a “pending” state until they register for UTR Sports and confirm the score.</li>
                            <li>Match score must have at least one player win 4 games in order to count for the rating (i.e. at least one set to 4 games).</li>
                            <li>Learn more about <a href={links.addScoreArticle} target="_blank" rel="noopener noreferrer" data-testid="post-score-page.a-393">entering scores</a> and <a href={links.algorithmUnderstandingLink} target="_blank" rel="noopener noreferrer" data-testid="post-score-page.a-393-183">how the rating works</a> on our support site.</li>
                        </ul>
                    );
                }
            } else {
                headerObject.title = isEdit ? 'Edit Your Score' : 'Post Your Score';
                headerObject.subTitle = `Self-post your score to count towards your rating`;
                let closeHandleClick = parsed.redirectUrl || '/home';
                if (playerMatchPostScore && !flexLeagueMatchPostScore) {
                    closeHandleClick = parsed.redirectUrl || (isEdit && state.currentPlayer ? `/profiles/${state.currentPlayer?.id}?t=1` : '/post-score-select');
                }
                headerObject.closeHandleClick = closeHandleClick;
                headerObject.titleInfo = (
                    <>
                        {(props.location?.search || props.location?.search?.includes('flexLeagues=true')) ? (
                            <ul>
                                <li>Once the score is posted, the opposing player has up to 4 days to confirm or deny the match score. If no action is taken, the match will be automatically confirmed at the end of 4 days. </li>
                                <li>If a match is denied, an email to your Flex League Manager will be needed to explain why you denied the match. If the score is inaccurate, please reach out to your opponent. </li>
                                <li>If you can’t agree on the score please fill out our <a href={links.matchProtestForm} target="_blank" rel="noopener noreferrer" data-testid="post-score-page.a-411-88"> match protest form.</a></li>
                                <li>For any other questions, please reference the UT Flex League <a href={links.flexLeagueRegulations} target="_blank" rel="noopener noreferrer" data-testid="post-score-page.a-412-97">  Rules & Regulations</a> or email <a href={`mailto:${FLEX_EMAIL}`} data-testid="post-score-page.a-412-251">{FLEX_EMAIL}</a></li>
                            </ul>
                        ) : (

                            <ul>
                                <li>Self-posted scores are not <a href={links.diffVerifiedUtr} target="_blank" rel="noopener noreferrer" data-testid="post-score-page.a-417-63">Verified</a>.</li>
                                <li>Only self-post scores from individual play. If you want to post scores from an <a href={links.countsToUTR} target="_blank" rel="noopener noreferrer" data-testid="post-score-page.a-418-115">organized event</a>, please contact the event organizer to post results for the entire event.</li>
                                <li>Your opponents must review and confirm the score before it is posted publicly on player profiles and counts for the rating. Until the score is confirmed, it will be in a “pending” state.</li>
                                <li>You can delete that you posted incorrectly.</li>
                                <li>Once the posted score is confirmed, everyone’s ratings will update by the next day.</li>
                                <li>If your opponent(s)/partner are not on UTR Sports, you will have to invite them via email. The score will remain in a “pending” state until they register for UTR Sports and confirm the score.</li>
                                <li>Match score must have at least one player win 4 games in order to count for the rating (i.e. at least one set to 4 games).</li>
                                <li>Learn more about <a href={links.addScoreArticle} target="_blank" rel="noopener noreferrer" data-testid="post-score-page.a-424-53">entering scores</a> and <a href={links.algorithmUnderstandingLink} target="_blank" rel="noopener noreferrer" data-testid="post-score-page.a-424-190">how the rating works</a> on our support site.</li>
                            </ul>

                        )}
                    </>

                );
            }
        } else if (clubPostScore) {
            const teamPostScore = club?.clubDetails?.tierType?.id === ClubTierTypes.HIGH_SCHOOL || club?.clubDetails?.tierType?.id === ClubTierTypes.PERFORMANCE_HIGH_SCHOOL;
            if (teamPostScore) {
                headerObject.title = isEdit ? 'Edit Team Score' : 'Post Scores';
                headerObject.subTitle = (
                    <>
                        Post JV, Challenge Matches, or any unofficial high school results.
                        <br />
                        To Post Dual Matches or Official High School results click <Link to={`/events/create?clubId=${clubId}`}>here</Link>
                    </>
                );
            } else {
                headerObject.title = isEdit ? 'Edit Club Score' : 'Post Club Scores';
                headerObject.subTitle = 'Post results for club members';
            }
        }
        dispatch(headerActions.setHeader(headerObject || {}));
    };

    const postUserScore = async (data) => {
        await dispatch(postScoreActions.postUserScore(data));
    };

    const addPlayer = (player, doubles) => {
        if (state.playerMatchPost) {
            return;
        }
        // Set search to lookup, and focus on search input
        let displayText = 'Add Player by Name';
        if (doubles) {
            if (player === 'pos2player1' || player === 'pos2player2') {
                displayText = 'Add Team 2 Player by Name';
            } else {
                displayText = 'Add Team 1 Player by Name';
            }
        } else if (player === 'pos2player1') {
            displayText = 'Add Player 2 by Name';
        } else {
            displayText = 'Add Player 1 by Name';
        }
        const lookUpParams = [];
        if (state.clubPost) {
            lookUpParams.push({
                key: 'clubId',
                value: club.clubId,
            });
        }
        if (state.playerEventPost) {
            lookUpParams.push({
                key: 'eventId',
                value: events.currentEvent.data.id,
            });
        }
        dispatch(searchActions.setSearchMode({
            mode: 'lookup',
            lookupType: 'players',
            lookUpParams,
            lookupCount: 40,
            lookup: player,
            displayText,
            allowInvite: !state.clubPost && !state.playerEventPost && !state.playerMatchPost,
            displayFilters: false,
            gotoSearchResults: false,
            sportTypeId,
        }));
    };

    const createTeamObject = (pos1player1, pos1player2) => {
        return {
            id: `${pos1player1.id}-${pos1player2.id}`,
            players: [
                pos1player1.id,
                pos1player2.id,
            ],
        };
    };

    const handlePostClick = async (data) => {
        try {
            const invitees = getInviteeList(data);
            if (invitees.length > 0) {
                // ask for emails of players to be invited
                setState((prevState) => ({
                    ...prevState,
                    invitees,
                    showInvites: true,
                    postData: data,
                }));
            } else {
                // post player score.
                setState((prevState) => ({
                    ...prevState,
                    showInvites: false,
                }));
                if (data) {
                    if (state.clubPost) {
                        data.clubId = club.clubId;
                    }
                    if (state.playerEventPost) {
                        data.eventId = events.currentEvent.data.id;
                    }
                    if (state.playerMatchPost) {
                        data.matchId = postScore.postableMatchups.currentMatchup.id;
                    }
                    data.sportTypeId = sportTypeId;

                    await postUserScore(data);
                } else {
                    console.log('Score hasn\'t been updated, not saving...');
                }
            }
        } catch (err) {
            console.log('err', err);
            dispatch(showErrorPopup({
                message: 'Post Score Failed!',
                error: err,
                showSupportLink: true,
            }));
        }
    };

    const loadNextMatch = (direction) => {
        // clear all match props
        setState((prevState) => ({
            ...prevState,
            externalClearFormData: true,
        }));

        if (!direction) {
            const { clubPost, playerPost } = state;
            if (clubPost) {
                const { clubType } = props.match.params;
                const { clubId } = club;
                props.history.push({
                    pathname: `/${clubType}/${clubId}`,
                    state: {
                        openResultsTab: true,
                    },
                });
            } else if (playerPost) {
                props.history.push({
                    pathname: `/home`,
                });
            } else {
                props.history.goBack();
            }
        }
    };

    const loadNextMatchForFlexLeague = (direction) => {
        // clear all match props
        setState((prevState) => ({
            ...prevState,
            externalClearFormData: true,
        }));

        if (direction === 'next') {
            props.history.push({
                pathname: parsed.redirectUrl || `/post-score-select`,
            });
        } else {
            props.history.push({
                pathname: `/home`,
            });
        }
    };

    const populateMatchPlayers = (match, playersDict, teamsDict) => {
        if ((match.position1.type && match.position1.type.value === 'player') || match.position1.typeId === drawPositionTypeIds.PLAYER) {
            match.pos1player1 = playersDict[match.position1.id];
        } else if ((match.position1.type && match.position1.type.value === 'team') || match.position1.typeId === drawPositionTypeIds.TEAM) {
            match.pos1player1 = playersDict[teamsDict[match.position1.id].players[0]];
            match.pos1player2 = playersDict[teamsDict[match.position1.id].players[1]];
        }

        if ((match.position2.type && match.position2.type.value === 'player') || match.position2.typeId === drawPositionTypeIds.PLAYER) {
            match.pos2player1 = playersDict[match.position2.id];
        } else if ((match.position2.type && match.position2.type.value === 'team') || match.position2.typeId === drawPositionTypeIds.TEAM) {
            match.pos2player1 = playersDict[teamsDict[match.position2.id].players[0]];
            match.pos2player2 = playersDict[teamsDict[match.position2.id].players[1]];
        }

        return match;
    };

    const updatePostDataWithInviteeEmails = async (values) => {
        const { postData } = state;
        const allFields = Object.keys(values);
        allFields.forEach((field) => {
            if (postData[field] && values[field]) {
                postData[field].email = values[field];
                postData[field].invite = false;
            }
        });
        handlePostClick(postData);
    };

    const componentConfigActionPerformed = (configType, actionName, selfPost, clubId) => {
        const params = {
            selfPost,
        };
        if (clubId) {
            params.clubId = clubId;
        }
        dispatch(postComponentActionPerformd('post-scores', configType, actionName, { properties: params }));
    };

    const shouldDisplaySportTypeSelection = !state.isEvent;
    const shouldDisplayDropdowns = shouldDisplaySportTypeSelection && !flexLeagueMatchPostScore;

    // rewrite route if type mistmatch
    if (clubPost && clubTierType && club.clubId === clubId) {
        if (clubType === 'clubs') {
            if (clubTierType.isCollege) {
                return <Redirect to={`/colleges/${clubId}/post-score`} />;
            }
            if (clubTierType.isHighSchool) {
                return <Redirect to={`/schools/${clubId}/post-score`} />;
            }
            if (isPersonalClub(clubTierType)) {
                return <Redirect to={`/groups/${clubId}/post-score`} />;
            }
        } else if (clubType === 'schools') {
            if (clubTierType.isCollege) {
                return <Redirect to={`/colleges/${clubId}/post-score`} />;
            }
            if (isPersonalClub(clubTierType)) {
                return <Redirect to={`/groups/${clubId}/post-score`} />;
            }
            if (!clubTierType.isHighSchool) {
                return <Redirect to={`/clubs/${clubId}/post-score`} />;
            }
        } else if (clubType === 'colleges') {
            if (clubTierType.isHighSchool) {
                return <Redirect to={`/schools/${clubId}/post-score`} />;
            }
            if (isPersonalClub(clubTierType)) {
                return <Redirect to={`/groups/${clubId}/post-score`} />;
            }
            if (!clubTierType.isCollege) {
                return <Redirect to={`/clubs/${clubId}/post-score`} />;
            }
        } else if (clubType === 'groups') {
            if (clubTierType.isCollege) {
                return <Redirect to={`/colleges/${clubId}/post-score`} />;
            }
            if (clubTierType.isHighSchool) {
                return <Redirect to={`/schools/${clubId}/post-score`} />;
            }
            if (!isPersonalClub(clubTierType)) {
                return <Redirect to={`/clubs/${clubId}/post-score`} />;
            }
        }
    }

    return (
        <div>
            <div className={`${styles.section}`}>
                {shouldDisplayDropdowns && (
                    <div className="container">
                        <div className="row">
                            <div className={`col-md-8 offset-md-2 pb0`}>
                                <div className={styles.content}>
                                    <h5 data-testid="post-score.page.match-sport-heading">
                                        Match Sport
                                    </h5>
                                    <div className="row">
                                        <div className="col-md-6 offset-md-3">
                                            {shouldDisplaySportTypeSelection && (
                                                <select className="form-control" value={sportTypeId} onChange={e => setSportTypeId(parseInt(e.target.value))} data-testid="post-score.page.sport-type-select">
                                                    <option value={sportTypeIds.TENNIS}>Tennis</option>
                                                    <option value={sportTypeIds.PICKLEBALL}>Pickleball</option>
                                                </select>
                                            )}
                                            <select className="form-control" value={gameTypeId} onChange={e => setGameTypeId(parseInt(e.target.value))} data-testid="post-score.page.game-type-select">
                                                <option value={divisionFormatTypeIds.SINGLES}>Singles</option>
                                                <option value={divisionFormatTypeIds.DOUBLES}>Doubles</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {!isSingleScore ? (
                    <PostScoreForm
                        externalClearFormData={state.externalClearFormData}
                        user={auth.user}
                        matchObj={state.match}
                        isEvent={false}
                        isPlayerPostVerifiedEvent={state.isVerifiedEvent}
                        clubPost={clubPost}
                        playerPost={playerPost}
                        playerEventPost={playerEventPost}
                        playerMatchPost={playerMatchPost}
                        teamPost={teamPostScore}
                        isEdit={isEdit}
                        handlePostClick={handlePostClick}
                        isFirstMatch={state.isFirstMatch}
                        isLastMatch={state.isLastMatch}
                        teamsDict={teamsDict}
                        addPlayer={addPlayer}
                        clearMatchData={() => {
                            setState((prevState) => ({
                                ...prevState,
                                externalClearFormData: false,
                            }));
                            dispatch(postScoreActions.clearMatchData());
                        }}
                        showCountsForRating={!playerPost && !isHighSchool}
                        defaultCountsForRating={true}
                        defaultVerifiedResultTo={false}
                        clubTierType={clubPost && clubTierType}
                        forceDoubles={forceDoubles}
                        sportTypeId={sportTypeId}
                    />
                ) : (
                    <PickleballPostScoreForm
                        externalClearFormData={state.externalClearFormData}
                        user={auth.user}
                        matchObj={state.match}
                        isEvent={false}
                        isPlayerPostVerifiedEvent={state.isVerifiedEvent}
                        clubPost={clubPost}
                        playerPost={playerPost}
                        playerEventPost={playerEventPost}
                        playerMatchPost={playerMatchPost}
                        teamPost={teamPostScore}
                        isEdit={isEdit}
                        handlePostClick={handlePostClick}
                        isFirstMatch={state.isFirstMatch}
                        isLastMatch={state.isLastMatch}
                        teamsDict={teamsDict}
                        addPlayer={addPlayer}
                        clearMatchData={() => {
                            setState((prevState) => ({
                                ...prevState,
                                externalClearFormData: false,
                            }));
                            dispatch(postScoreActions.clearMatchData());
                        }}
                        showCountsForRating={!playerPost && !isHighSchool}
                        defaultCountsForRating={true}
                        defaultVerifiedResultTo={false}
                        clubTierType={clubPost && clubTierType}
                        forceDoubles={forceDoubles}
                    />
                )}
                {showInvites && invitees && invitees.length > 0 && (
                    <div className="overlay" data-testid="post-score.page.invite-overlay">
                        <Form onSubmit={values => { updatePostDataWithInviteeEmails(values); }}>
                            {({ submitForm, values }) => {
                                const isEmpty = value => value === undefined || value === null || value === '';
                                const checkEmail = (value, currentKey) => {
                                    let error;
                                    if (isEmpty(value)) {
                                        error = 'This field is required.';
                                    } else if (!isEmpty(value) && !isValidEmail(value)) {
                                        error = 'This does not appear to be a valid email';
                                    } else if (value === auth.user.email) {
                                        error = 'Invitee email should not match your email';
                                    } else {
                                        const allFields = Object.keys(values);
                                        allFields.forEach((field) => {
                                            if (field !== currentKey && values[field] === value) {
                                                error = 'Invitee emails should not match';
                                            }
                                        });
                                    }
                                    return {
                                        error,
                                    };
                                };
                                return (
                                    <form onSubmit={submitForm} id="playerInviteForm" data-testid="post-score.page.invite-form">
                                        <div className={`container`}>
                                            <div className="row">
                                                <div className="col-12 col-md-8 offset-md-2">
                                                    <div className="icon paper-plane-icon" />
                                                    <p className="text-highlight2 text-teal" data-testid="post-score.page.invite-heading">
                                                        You played someone new
                                                    </p>
                                                    <p data-testid="post-score.page.invite-description">{`Invite ${invitees.length === 1 ? invitees[0].firstName : 'the players'} to join UTR Sports and confirm this pending result.`}</p>
                                                </div>
                                            </div>
                                            <div className="row text-left">
                                                <div className="col-12 col-md-6 offset-md-3">
                                                    {invitees.map((invitee) => {
                                                        return (
                                                            <Input
                                                                id={`${invitee.key}`}
                                                                field={`${invitee.key}`}
                                                                key={`email-${invitee.key}`}
                                                                type="text"
                                                                description={`Enter ${invitee.firstName} ${invitee.lastName}'s email`}
                                                                placeholder="Email address"
                                                                validate={(value) => checkEmail(value, invitee.key)}
                                                                data-testid="postscorepage.item-input"
                                                            />
                                                        );
                                                    })}
                                                    <button
                                                        type="submit"
                                                        className="btn btn-primary btn-xl btn-block text-uppercase mt16"
                                                        data-testid="post-score.page.invite-send-btn"
                                                    >
                                                        Send
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                );
                            }}
                        </Form>
                    </div>
                )}
            </div>
            {/* {postScore.submitted && playerMatchPost && (!isEdit || flexLeagueMatchPostScore) && (
                <Redirect to={`/home`} />
            )} */}
            {postScore.submitted && playerMatchPost && flexLeagueMatchPostScore && (
                <ScorePostedConfirmationPopup
                    onCtaClick={(direction) => {
                        loadNextMatchForFlexLeague(direction);
                    }}
                    invitees={invitees}
                    playerMatchPost={state.playerMatchPost}
                    flexLeagueMatchPostScore={flexLeagueMatchPostScore}
                />
            )}
            {postScore.submitted && playerMatchPost && !isEdit && !flexLeagueMatchPostScore && (
                <Redirect to={`/home`} />
            )}
            {postScore.submitted && playerMatchPost && isEdit && !flexLeagueMatchPostScore && (
                <Redirect to={`/profiles/${state.currentPlayer.id}?t=1`} /> // player profile tab results
            )}
            {postScore.submitted && !playerMatchPost && (
                <ScorePostedConfirmationPopup
                    onCtaClick={(direction) => {
                        loadNextMatch(direction);
                    }}
                    invitees={invitees}
                    clubPost={state.clubPost}
                />
            )}
            {postWelcomePopUpConfig && showWelcomePopUp && (
                <PostScoreWelcomePopUp
                    welcomeTitles={welcomeTitles}
                    onCloseClick={() => {
                        setState((prevState) => ({
                            ...prevState,
                            showWelcomePopUp: false,
                        }));
                        componentConfigActionPerformed(postWelcomePopUpConfig.type, postWelcomePopUpConfig.actions.dismissed.event, playerPost, clubId);
                    }}
                    onCtaClick={() => {
                        setState((prevState) => ({
                            ...prevState,
                            showWelcomePopUp: false,
                        }));
                        componentConfigActionPerformed(postWelcomePopUpConfig.type, postWelcomePopUpConfig.actions.confirmed.event, playerPost, clubId);
                    }}
                />
            )}
        </div>
    );
};

export default requireAuth(PostScorePage);
